import { flatten, unflatten } from 'flat'

export function fallbackValues(page, fallback = {}) {
  const flatPage = flatten(page)
  const flatFallback = flatten(fallback)

  const cleanedPage = {}
  for (let key of Object.keys(flatPage)) {
    if (!flatPage[key] || flatPage[key].length === 0) continue
    cleanedPage[key] = flatPage[key]
  }

  const flatPageData = { ...flatFallback, ...cleanedPage }
  return unflatten(flatPageData)
}
